<template>
    <div class="reportEatXfbm defaultReport">
        <div class="filter-box">
            <div class="filter-bnts ">
                
                <div class="inline-block">
                    <span class="lable-txt">POS状态：</span>
                    <el-select v-model="posStatus">
                        <el-option :value="0" label="全部"></el-option>
                        <el-option :value="1" label="停售"></el-option>
                        <el-option :value="2" label="可售"></el-option>
                    </el-select>
                </div>
                <div class="inline-block">
                    <span class="lable-txt">线上状态：</span>
                    <el-select v-model="onlineStatus">
                        <el-option :value="0" label="全部"></el-option>
                        <el-option :value="1" label="下架"></el-option>
                        <el-option :value="2" label="上架"></el-option>
                    </el-select>
                </div>
                <div class="inline-block">
                    <el-checkbox v-model="isMultUnit" label="仅显示多单位菜品" ></el-checkbox>
                </div>
                <div class="inline-block">
                    <el-checkbox v-model="isNotShowTc" label="仅显示套餐" ></el-checkbox>
                </div>
               <div class="bnt-search" @click="loadData()">刷新</div>
            </div>
            <div class="right-bnts">
                <div class="bnt" @click="exportExcel()"><i class="iconfont icon-daochu"></i>导出报表</div>
            </div>
        </div>
        <div class="data-box">
            <div class="left-table table-box">
                <el-tree
                    ref="treeRef"
                    class="filter-tree"
                    :data="treeData"
                    :expand-on-click-node="false"
                    highlight-current
                    default-expand-all
                    @current-change="currentChange"
                />
            </div>
            <div class="right-table content-box">
                <div class="table-box grey-table">
                    <el-table class="el-table--scrollable-y" style="width: 100%;height:100%"  v-mouse-scroll="{scrollName:'.el-table__body-wrapper'}"
                        ref="tableEl"
                        border
                        highlight-current-row
                        @cell-dblclick="dblclick"
                        :data="pageTableData"
                        :cell-class-name="setClassName"
                    >
                        <el-table-column fixed prop="Eat_XfCode" label="编码" min-width="100" align="left">
                            <template #default="scope">
                                <span v-copyText>{{scope.row.Eat_XfCode}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column fixed prop="Eat_XfName" label="名称" min-width="130" align="left">
                            <template #default="scope">
                                <span class="multUnit" v-if="scope.row.Is_MoreSize">多</span>
                                <div class="moreUnit" v-if="scope.row.Is_MoreSize" :class="{isRight:scope.row.Eat_ParentId}">
                                     <span v-copyText>{{scope.row.Eat_XfName}}</span>
                                </div>
                                <div v-else>
                                    <span v-copyText>{{scope.row.Eat_XfName}}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Eat_KindName" label="上级分类" min-width="100" align="left"></el-table-column>
                        <el-table-column prop="Chh_DepartName" label="出品部门" min-width="100" align="left"></el-table-column>
                        <el-table-column prop="Eat_Size" label="单位" min-width="80" align="left"></el-table-column>
                        <el-table-column prop="Eat_XfPrice" label="单价" min-width="80" :formatter="priceFormat" data-format="number" align="right"></el-table-column>
                        <el-table-column prop="Eat_XfPrice" label="售价" min-width="80" :formatter="priceFormat" data-format="number" align="right"></el-table-column>
                        <el-table-column prop="Eat_ParPrice" label="会员价" min-width="80" :formatter="priceFormat" data-format="number" align="right"></el-table-column>

                        <el-table-column prop="Yx" label="POS可售状态" min-width="100">
                            <template #default="scope">
                                <template v-if="scope.isExcel">{{scope.row.Yx?"可售":"停售"}}</template>
                                <el-switch v-else size="large" v-model="scope.row.Yx" disabled
                                    inline-prompt inactive-color="#8A8A8A" :width="48" active-text="可售" inactive-text="停售"></el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Is_Move" label="线上售卖状态" min-width="100">
                            <template #default="scope">
                                <template v-if="scope.isExcel">{{scope.row.Is_Move?"下架":"上架"}}</template>
                                <el-switch v-else size="large" v-model="scope.row.Is_Move" disabled
                                    inline-prompt inactive-color="#8A8A8A" :width="48"  
                                    :active-value="false"
                                    :inactive-value="true"
                                    active-text="上架" inactive-text="下架"></el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Eat_ParentName" label="多单位关联主菜" min-width="100" align="left"></el-table-column>
                        <el-table-column prop="Coefficient" label="多单位子项份量系数" min-width="120" align="right">
                            <template #default="scope">
                                {{(scope.row.Is_MoreSize && scope.row.Eat_ParentId)?scope.row.Coefficient:''}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="Eat_AssSize" label="辅助单位" min-width="80" align="left"></el-table-column>
                        <el-table-column prop="Eat_NOZK" label="永不打折" min-width="80" :formatter="boolFormat" ></el-table-column>
                        <el-table-column prop="Eat_ZKYN" label="可折" min-width="80" :formatter="boolFormat" ></el-table-column>
                        <el-table-column prop="Eat_Enable" label="时价菜" min-width="80" :formatter="boolFormat"></el-table-column>
                        <el-table-column prop="Eat_LimitYN" label="限量销售" min-width="80" :formatter="boolFormat"></el-table-column>
                        <el-table-column prop="Eat_UpdateYN" label="可改量" min-width="80" :formatter="boolFormat"></el-table-column>
                        <el-table-column prop="Eat_FWFYN" label="收取服务费" min-width="80" :formatter="boolFormat"></el-table-column>
                        <el-table-column prop="Eat_DXYN" label="代销商品" min-width="80" :formatter="boolFormat"></el-table-column>
                        <el-table-column prop="Eat_TCYN" label="套餐" min-width="80" :formatter="boolFormat" ></el-table-column>
                        <el-table-column prop="Is_Special" label="特色菜" min-width="80" :formatter="boolFormat" ></el-table-column>
                        <el-table-column prop="Is_TakeOut" label="线上销售" min-width="80" :formatter="boolFormat" ></el-table-column>
                        <el-table-column prop="Is_CountByUnit" label="按点击次数统计点击率" min-width="130" :formatter="boolFormat"></el-table-column>
                        <el-table-column prop="Is_MoreSize" label="是否为多单位菜品" min-width="100" :formatter="boolFormat" ></el-table-column>
                        <el-table-column prop="Is_PadNOShow" label="是否Pad不显示本菜" min-width="120" :formatter="boolFormat"></el-table-column>
                        <el-table-column prop="Is_CheckInt" label="是否菜品数量只能整数" min-width="130" :formatter="boolFormat"></el-table-column>
                        <el-table-column prop="Item_KindName" label="产品属性" min-width="80" align="left"></el-table-column>
                        <el-table-column prop="KitPlace_Name" label="出单位置" min-width="80" align="left"></el-table-column>
                        <el-table-column prop="Kit_Level" label="菜品等级" min-width="80" align="right"></el-table-column>
                        <el-table-column prop="Kit_Length" label="制作标准时长" min-width="100" align="right"></el-table-column>
                        <el-table-column prop="AchiveCoefficient" label="绩效系数" min-width="80" align="right"></el-table-column>
                        <el-table-column prop="Cook_Rate" label="制作难度系数" min-width="100" align="right"></el-table-column>
                        <el-table-column prop="Is_KDSNOShow" label="是否KDS不显示" min-width="100" :formatter="boolFormat"></el-table-column>
                    </el-table>
                </div>
                <div class="search-box">
                    <key-board-input class="search"
                        type="text" v-model="searchTxt" placeholder="菜品名称、编码或助记码模糊检索"
                            isBlurClose
                    ></key-board-input>
                    <div class="float-right">
                        <span class="last-page iconfont icon-fangxiangquan-left" @click="billPage()"></span>
                        <span class="page-number">{{ tablePageIndex+1 }}/{{ tablePageSum }}页</span>
                        <span class="next-page iconfont icon-fangxiangquan-right" @click="billPage(1)" ></span>
                        <div class="page-bnt">
                            <el-select v-model="pageSize"  >
                                <el-option :value="20" label="20条/页"></el-option>
                                <el-option :value="30" label="30条/页"></el-option>
                                <el-option :value="50" label="50条/页"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <set-meal-only-look-model :isShow="isTcShow" @closeModel="isTcShow=false" :setMealInfo="setMealInfo" />
     </div>
</template>
<script>
/**菜品信息一览表 */
export default {
    name:'reportEatXfbm',
    data(){
        return {
            //选中的节点
            currentNode:null,
            foodMainCategory:[],
            tablePageIndex:0,
            pageSize:20,//每页的数据条数
            tableList:[],
            //分页显示数据
            tableListPage:[],
            //检索
            searchTxt:"",
            //pos状态
            posStatus:0,
            //线上状态
            onlineStatus:0,
            isMultUnit:false,
            isNotShowTc:false,
            //套餐弹层
            isTcShow:false,
            setMealInfo:null
        }
    },
    computed:{
        treeData(){
            let tree=[];
            this.foodMainCategory?.forEach(category=>{
                let children=[];
                category.FoodSubCategorys?.forEach(sub=>{
                    children.push({
                        id:sub.SubCategory_ID,
                        label:(sub.SubCategory_Code+"-"+sub.SubCategory_Name).replace(/^[-]/,""),
                        SubCategory_ID:sub.SubCategory_ID,
                    })
                });
                
                tree.push({
                    id:category.MainCategory_ID,
                    label:(category.MainCategory_Code+"-"+category.MainCategory_Name).replace(/^[-]/,""),
                    children:children
                });
            })
            return [{label:"全部",children:tree,id:0}];
        },
        tableData(){
            let posFoods=this.tableList||[];
            if(this.currentNode?.children){
                let foods=[];
                let category= this.foodMainCategory.find(t=>t.MainCategory_ID==this.currentNode.id);
                if(category){
                    foods=posFoods.filter(t=>category.FoodSubCategorys.some(it=>it.SubCategory_ID==t.Eat_KindId));
                }
                posFoods= foods;
            }else if(this.currentNode){
                posFoods=posFoods.filter(t=>t.Eat_KindId==this.currentNode.id);
            }
            return posFoods;
        },
        //条件筛选
        tableFilter(){
            let list=Object.assign([],this.tableData);
            if(list && list.length>0){
                if(this.searchTxt!=''){
                    let seach=this.searchTxt.toUpperCase();
                    list=list.filter(it=>
                        (it.Eat_XfCode||'').toUpperCase().indexOf(seach)>=0 
                        || (it.Eat_XfName||'').toUpperCase().indexOf(seach)>=0
                        || (it.Eat_PinYin||'').toUpperCase().indexOf(seach)>=0
                    );
                }

                if(this.posStatus==1){//停售
                    list=list.filter(it=>!it.Yx);
                }else if(this.posStatus==2){//可售
                    list=list.filter(it=>it.Yx);
                }
                if(this.onlineStatus==1){//下架
                    list=list.filter(it=>it.Is_Move);
                }else if(this.onlineStatus==2){//上架
                    list=list.filter(it=>!it.Is_Move);
                }
                if(this.isNotShowTc){//仅显示套餐的菜
                    list=list.filter(it=>it.Eat_TCYN);
                }
                if(this.isMultUnit){//仅显示多单位
                    list=list.filter(it=>it.Is_MoreSize);//多单位的菜
                }
                
            }
            return list;
        },
        /**分页数据 */
        pageTableData(){
            return this.tableFilter.slice(this.tablePageIndex*this.pageSize,(this.tablePageIndex+1)*this.pageSize);
        },
        tablePageSum(){
            let length=this.tableFilter.length;
            if(length>1){
                return Math.ceil(length/this.pageSize);
            }
            return 1;
        },
    },
    mounted(){
        //渠道数据
        this.$cacheData.OrderChannel().then((d)=>{
            if(d){
                this.orderChannel=d;
            }
        }).catch((e)=>{
            this.$message.error('加载渠道数据失败：'+e.message);
            console.log('加载渠道数据失败：'+e);
        })

        this.loadData();
    },
    watch:{
        tableFilter(){
            this.tablePageIndex=0;
        }
    },
    methods:{
        /**Excel导出 */
        exportExcel(){
            if(!this.$cacheData?.globalVariable?.GlobalSysSetting.AllowUserPrintReports){
                this.$message.warning('您没有导出报表权限，请先分配权限！');
                return;
            }
            this.$excelCommon.elTableToExcel({
                elTable:this.$refs.tableEl,
                titleName:"菜品信息一览表",
                list:this.tableFilter,
                colFormat:(row,column)=>{
                    let json={};
                    //t 类型  b布尔值，n数字，e错误，s字符串，d日期，z存根
                    if(column.property=="Eat_Number"){
                        json.t='n';
                    }
                    return json;
                }
            })

            
        },
         /*单价格式 截取两位小数 */
        priceFormat(row, column, cellValue){
            if(isNaN(cellValue)){
                return ""
            }else{
                return parseFloat(parseFloat(cellValue).toFixed(2));
            }
        },
        /*时间格式 */
        boolFormat(row, column, cellValue) {
            return cellValue?"是":"否";
        },
        /**查看套餐 */
        showTc(info){

            this.loadFoodSetMealInfo(info.Eat_XfbmId).then(data=>{
                if(data && data.SetMealInfoList?.length>0){
                    this.isTcShow=true;
                    this.setMealInfo=data.SetMealInfoList[0];
                }
            });
        },
        /**查询 菜品套餐信息 */
        loadFoodSetMealInfo(Food_ID){
            const userInfo = this.$auth.getUserInfo();

            let param={
                User_ID:userInfo?.User_ID,
                Operator_Name:userInfo?.Login_Name,
                Food_ID:Food_ID
            }
            const loading = this.$loading({
                text: "查询中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });

            return this.$httpAES.post("Bestech.CloudPos.FoodSetMealInfoReport",param).then((d)=>{
                console.log(d);
                loading.close();
                if(d.ResponseHeader.ResultCode==0){
                    return d.ResponseBody;
                }else{
                    this.$message.error(d.ResponseHeader.ResultDesc);
                }
            }).catch((e)=>{
                loading.close();
                this.$message.error(e.message);
                console.log(e);
            })
        },
        //设置单元格类名
        setClassName({ row, column }){
            if(column.property=="Eat_XfName" && row.Eat_TCYN){
                return "tc";
            }
        },
        dblclick(row,column){
            if(column.property=="Eat_XfName" && row.Eat_TCYN){
                this.showTc(row)
            }
        },
        currentChange(node){
            if(node.id!=0){
                this.currentNode=node;
            }else{
                this.currentNode=null;
            }
            
        },
        /**数据分页 */
        billPage(type){
            if(type==1){
                if(this.tablePageIndex+1<this.tablePageSum){
                    this.tablePageIndex++;
                }else{//下一页
                    this.$message.warning('已到最后一页');
                }
            }else{//上一页
                if(this.tablePageIndex==0){
                    this.$message.warning('已到第一页');
                }
                this.tablePageIndex>0?this.tablePageIndex--:this.tablePageIndex=0;
            }
        },
        setMainCategory(data){
            this.currentNode=null;
            let mainCategory=[];
            let mainKey={};
            data.forEach(it=>{
                if(!mainKey[it.Eat_MainKindId]){
                    mainKey[it.Eat_MainKindId]={
                        MainCategory_ID:it.Eat_MainKindId,
                        MainCategory_Code:it.Eat_MainKindCode,
                        MainCategory_Name:it.Eat_MainKindName,
                        FoodSubCategorys:[],
                        subKey:{}
                    };
                    mainCategory.push(mainKey[it.Eat_MainKindId]);
                }

                if(!mainKey[it.Eat_MainKindId].subKey[it.Eat_KindId]){
                    mainKey[it.Eat_MainKindId].subKey[it.Eat_KindId]={
                        SubCategory_ID:it.Eat_KindId,
                        SubCategory_Code:it.Eat_KindName,
                        SubCategory_Name:it.Eat_KindCode
                    }
                    mainKey[it.Eat_MainKindId].FoodSubCategorys.push(mainKey[it.Eat_MainKindId].subKey[it.Eat_KindId]);
                }
            })
            this.foodMainCategory=mainCategory;
        },
        /**查询 */
        loadData(){
            const userInfo = this.$auth.getUserInfo();

            let param={
                User_ID:userInfo?.User_ID,
                Operator_Name:userInfo?.Login_Name,
            }
            const loading = this.$loading({
                text: "查询中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });

            this.$httpAES.requestConfig({timeout:60*1000}).post("Bestech.CloudPos.FoodInfoViewReport",param).then((d)=>{
                console.log(d);
                loading.close();
                if(d.ResponseHeader.ResultCode==0){
                    this.tableList=d.ResponseBody;
                    this.setMainCategory(d.ResponseBody);
                }else{
                    this.tableList=[];
                    this.$message.error(d.ResponseHeader.ResultDesc);
                }
            }).catch((e)=>{
                loading.close();
                this.$message.error(e.message);
                console.log(e);
            })
        },
    }
}
</script>

<style lang="scss" >
@import './reportEatXfbm.scss'
</style>